import React from 'react'
import { useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { t } from '@lingui/core/macro'
import { HttpError } from '../../types/ApiError'
import NotFoundPage from '../../pages/ErrorPage/NotFoundPage'
import LoadDataErrorPage from '../../pages/ErrorPage/LoadDataErrorPage'

const PaymentPageErrorBoundary = () => {
    const error = useRouteError()

    // Проверяем, является ли это Response с HTTP статусом или HttpError
    if (isRouteErrorResponse(error) || error instanceof HttpError) {
        if (error.status === 404) {
            return <NotFoundPage />
        }

        return <LoadDataErrorPage title={t`Ошибка загрузки данных`} description={t`Не удалось загрузить информацию. Попробуйте обновить страницу.`} />
    }

    // Тут должна быть общая страница ошибки, но пока ее нет
    return <LoadDataErrorPage title={t`Ошибка загрузки данных`} description={t`Не удалось загрузить информацию. Попробуйте обновить страницу.`} />
}

export default PaymentPageErrorBoundary
